import { useEffect, useState } from "react";
import Pagination from '../pagination/Pagination.jsx'
import { colorizeTextPoints, PlainExplainPoints } from '../ExplainPoints.jsx'
import { Tooltip } from 'react-tooltip'
import { enshortenName } from "../../utils/string.js"
import { LoadStandingsAuditMatch } from "../../repo/GroupsRepo.js";

export default function MatchDetailsStartedAudit({groupId, match, bet, standingsAuditMatchPage, ...props}) {
  const [users, setUsers] = useState(null)
  const [pagination, setPagination] = useState(null)
  const [currentStandingsAuditMatchPage, setCurrentStandingsAuditMatchPage] = useState(standingsAuditMatchPage || 1)

  function handlePaginationClick(newStandingsAuditMatchPage) {
    setCurrentStandingsAuditMatchPage(newStandingsAuditMatchPage)
  }

  async function loadStandingsAuditMatch(match, groupId, standingsAuditMatchPage) {
    const resData = await LoadStandingsAuditMatch(match, groupId, standingsAuditMatchPage)

    setUsers(resData.data)
    setPagination(resData.pagination)
  }

  useEffect(() => {
    loadStandingsAuditMatch(match, groupId, currentStandingsAuditMatchPage)
  }, [match, groupId, currentStandingsAuditMatchPage])

  return (
    <div className="grid grid-cols-2 gap-4 rounded-b-lg">
      {users && users.length > 0 &&
      <>
          {users.map((user) => (
            <div className="text-center px-4 py-1 text-xs" key={"match-audit-user-" + user.id + "-group-" + groupId + "-match-" + match.id}>
              {match.is_ended && (
                <>
                  <span className={`font-bold ${colorizeTextPoints(user.bet_points)}`} id={`match-audit-user-${groupId}-${user.id}-${match.id}`}>
                    {enshortenName(user.user_name)} fez {user.bet_points} pts ({user.bet_guess_score_team_a} x {user.bet_guess_score_team_b})
                  </span>
                  <Tooltip anchorSelect={`#match-audit-user-${groupId}-${user.id}-${match.id}`} place="top" type="dark" effect="float">
                    {<PlainExplainPoints points={user.bet_points} />}
                  </Tooltip>
                </>
              )}
              {!match.is_ended && (
                <>{enshortenName(user.user_name)}: {user.bet_guess_score_team_a} x {user.bet_guess_score_team_b}</>
              )}
            </div>
          ))}
        <Pagination pagination={pagination} onPaginationClick={handlePaginationClick} />
      </>
      }
      {users && users.length === 0 && (
        <div className="px-4 py-1 w-full text-xs">
          Ninguém palpitou nesse jogo
        </div>
      )}
    </div>
  )
}
